import { FormFieldAnswerType } from "@/graphql";

export const RESPONSE_TYPES = [
  { value: FormFieldAnswerType.RatingScale, name: "Rating Scale" },
  { value: FormFieldAnswerType.SingleLine, name: "Single Line" },
  { value: FormFieldAnswerType.MultiLine, name: "Multi Line" },
];

export const RATING_SCALE_OPTION_TEMPLATES: {
  name: string;
  options: { value: string; label: string }[];
}[] = [
  {
    name: "Agreement",
    options: [
      {
        value: "1",
        label: "Strongly Disagree",
      },
      {
        value: "2",
        label: "Disagree",
      },
      {
        value: "3",
        label: "Neither agree nor disagree",
      },
      {
        value: "4",
        label: "Agree",
      },
      {
        value: "5",
        label: "Strongly Agree",
      },
    ],
  },
  {
    name: "Likelihood",
    options: [
      {
        value: "1",
        label: "Very Unlikely",
      },
      {
        value: "2",
        label: "Unlikely",
      },
      {
        value: "3",
        label: "Neither likely nor unlikely",
      },
      {
        value: "4",
        label: "Likely",
      },
      {
        value: "5",
        label: "Very Likely",
      },
    ],
  },
  {
    name: "Confidence",
    options: [
      {
        value: "1",
        label: "Not at all confident",
      },
      {
        value: "2",
        label: "Slightly confident",
      },
      {
        value: "3",
        label: "Moderately confident",
      },
      {
        value: "4",
        label: "Very confident",
      },
      {
        value: "5",
        label: "Extremely confident",
      },
    ],
  },
  {
    name: "Frequency",
    options: [
      {
        value: "1",
        label: "Never",
      },
      {
        value: "2",
        label: "Rarely",
      },
      {
        value: "3",
        label: "Sometimes",
      },
      {
        value: "4",
        label: "Often",
      },
      {
        value: "5",
        label: "Always",
      },
    ],
  },
  {
    name: "Satisfaction",
    options: [
      {
        value: "1",
        label: "Very dissatisfied",
      },
      {
        value: "2",
        label: "Dissatisfied",
      },
      {
        value: "3",
        label: "Neither satisfied nor dissatisfied",
      },
      {
        value: "4",
        label: "Satisfied",
      },
      {
        value: "5",
        label: "Very Satisfied",
      },
    ],
  },
  {
    name: "Difficulty",
    options: [
      {
        value: "1",
        label: "Very easy",
      },
      {
        value: "2",
        label: "Easy",
      },
      {
        value: "3",
        label: "Neither easy nor difficult",
      },
      {
        value: "4",
        label: "Difficult",
      },
      {
        value: "5",
        label: "Very difficult",
      },
    ],
  },
  {
    name: "Importance",
    options: [
      {
        value: "1",
        label: "Not at all important",
      },
      {
        value: "2",
        label: "Slightly important",
      },
      {
        value: "3",
        label: "Moderately important",
      },
      {
        value: "4",
        label: "Very important",
      },
      {
        value: "5",
        label: "Extremely important",
      },
    ],
  },
] as const;
